import CaptainMcpServersAPI from 'dashboard/api/captain/mcpServers';
import { createStore } from './storeFactory';

export default createStore({
  name: 'CaptainMcpServer',
  API: CaptainMcpServersAPI,
});
